module.exports = __webpack_public_path__ + "img/arr-right.e0379de4.svg";